<div class="flex flex-col gap-1">

  <label class="kt-form-label font-medium text-xs mb-1">
    {{ field.label }}
  </label>

  <select
    class="kt-input kt-input-sm"
    [formControl]="control">

    <option value="">
      -- Select --
    </option>

    <option
      *ngFor="let o of options"
      [value]="o.value">

      {{ o.label }}

    </option>

  </select>

  <mat-error *ngIf="isInvalid">

    {{ getError() }}

  </mat-error>

</div>